import {
  ContentPageType,
  ManageContentPage,
} from '@api/contentPagesApi/interfaces';
import { ChipProps } from '@mui/material';
import { ROUTES } from '@routes/routes';

const NAVIGABLE_CONTENT_PAGE_TYPES: ContentPageType[] = [
  'news-item',
  'association-instruction',
  'association-rules-and-regulations',
];

export const isNavigableContentPageType = (
  type: ContentPageType
): boolean => {
  return NAVIGABLE_CONTENT_PAGE_TYPES.includes(type);
};

export const getPortalContentPageRoute = (
  type: ContentPageType,
  slug: string
): string => {
  if (type === 'association-rules-and-regulations') {
    return ROUTES.portal.association.rulesAndRegulations.details(slug);
  }

  if (type === 'association-instruction') {
    return ROUTES.portal.association.instructions.details(slug);
  }

  if (type === 'news-item') {
    return ROUTES.portal.news.details(slug);
  }

  return '';
};

export const getManageContentPageRoute = (
  type: ContentPageType,
  id: number
): string => {
  if (type === 'association-rules-and-regulations') {
    return ROUTES.manage.association.rulesAndRegulations.details(id);
  }

  if (type === 'association-instruction') {
    return ROUTES.manage.association.instructions.details(id);
  }

  if (type === 'news-item') {
    return ROUTES.manage.news.details(id);
  }

  return '';
};

export const getBadgeColor = (
  value: ManageContentPage['status']
): ChipProps['color'] => {
  if (value === 'published') {
    return 'success';
  }

  if (value === 'scheduled') {
    return 'info';
  }

  return 'light';
};
